import { SelectChangeEvent } from '@mui/material';
import { useFormikContext } from 'formik';
import { useCallback } from 'react';

import { ResourcesPageFormValues } from '../../../../../../pages/ResourcesPage';

export const useReplaceValueAt = (index: number, arrayReplace: (index: number, value: any) => void) => {
    const { values } = useFormikContext<ResourcesPageFormValues>();

    return useCallback(
        (prop: string, event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
            arrayReplace(index, {
                ...values.resources[index],
                content: {
                    ...values.resources[index].content,
                    [prop]: event.target.value,
                },
            });
        },
        [arrayReplace, index, values.resources],
    );
};

export const useReplaceNumberAt = (index: number, arrayReplace: (index: number, value: any) => void) => {
    const { values } = useFormikContext<ResourcesPageFormValues>();

    return useCallback(
        (prop: string, event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
            arrayReplace(index, {
                ...values.resources[index],
                content: {
                    ...values.resources[index].content,
                    [prop]: Number(event.target.value),
                },
            });
        },
        [arrayReplace, index, values.resources],
    );
};

export const useReplaceSelectAt = (index: number, arrayReplace: (index: number, value: any) => void) => {
    const { values } = useFormikContext<ResourcesPageFormValues>();

    return useCallback(
        (prop: string, event: SelectChangeEvent<string>) => {
            arrayReplace(index, {
                ...values.resources[index],
                content: {
                    ...values.resources[index].content,
                    [prop]: event.target.value,
                },
            });
        },
        [arrayReplace, index, values.resources],
    );
};
